import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import React from 'react';

export const FullScreenButton = ({ onClick = () => {}, className = '' }) => {
  return (
    <Button
      variant="outline"
      size="sm"
      className={clsx('shadow-search gap-2 p-2.5', className)}
      onClick={onClick}
    >
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.6514 0.0254211C14.8426 0.0254211 15.0273 0.09003 15.1738 0.208038L15.2334 0.261749C15.3878 0.413454 15.4746 0.619664 15.4746 0.834015V4.8848H13.8281V2.79007L13.7861 2.83011L10.6904 5.77835L10.6426 5.73343C10.6021 5.69574 10.546 5.64372 10.4854 5.58694C10.3641 5.47338 10.2229 5.34073 10.1436 5.26273C10.0637 5.18429 9.91928 5.04574 9.79492 4.92679C9.73269 4.86726 9.67548 4.81224 9.63379 4.77249C9.61297 4.75264 9.59572 4.73679 9.58398 4.72562L9.58301 4.72464L12.6191 1.68558L12.6611 1.64261H10.4346V0.0254211H14.6514Z"
          fill="#05050D"
          fillOpacity="0.8"
          stroke="white"
          strokeWidth="0.05"
        />
        <path
          d="M1.34863 13.9399C1.15738 13.9399 0.972707 13.8753 0.826172 13.7573L0.766602 13.7036C0.612218 13.5519 0.525391 13.3457 0.525391 13.1313L0.52539 9.08057L2.17187 9.08057L2.17187 11.1753L2.21387 11.1353L5.30957 8.18701L5.35742 8.23193C5.39792 8.26962 5.45402 8.32165 5.51465 8.37842C5.63593 8.49198 5.77706 8.62463 5.85644 8.70264C5.93627 8.78108 6.08072 8.91962 6.20508 9.03857C6.26731 9.0981 6.32452 9.15312 6.36621 9.19287C6.38703 9.21272 6.40428 9.22857 6.41602 9.23975L6.41699 9.24072L3.38086 12.2798L3.33887 12.3228L5.56543 12.3228L5.56543 13.9399L1.34863 13.9399Z"
          fill="#05050D"
          fillOpacity="0.8"
          stroke="white"
          strokeWidth="0.05"
        />
        <path
          d="M15.4375 13.1659C15.4375 13.3533 15.3718 13.5347 15.252 13.6786L15.1973 13.7382C15.0429 13.8899 14.8328 13.9755 14.6143 13.9755L10.4912 13.9755L10.4912 12.3573L12.624 12.3573L12.582 12.3153L9.58203 9.27429C9.59279 9.2631 9.60889 9.24717 9.62793 9.22742C9.66627 9.18764 9.7187 9.13258 9.77637 9.07312L10.1064 8.73718C10.1863 8.65873 10.3281 8.51666 10.4492 8.39441C10.5097 8.3334 10.5651 8.27709 10.6055 8.23621C10.6257 8.21576 10.642 8.1989 10.6533 8.18738L10.6543 8.1864L13.749 11.1698L13.791 11.2098L13.791 9.02234L15.4375 9.02234L15.4375 13.1659Z"
          fill="#05050D"
          fillOpacity="0.8"
          stroke="white"
          strokeWidth="0.05"
        />
        <path
          d="M0.52539 0.834229C0.52539 0.646785 0.591065 0.465417 0.710937 0.321533L0.765625 0.261963C0.920023 0.110243 1.13009 0.0246582 1.34863 0.0246582L5.47168 0.024658L5.47168 1.64282L3.33887 1.64282L3.38086 1.68481L6.38086 4.72583C6.3701 4.73702 6.354 4.75295 6.33496 4.7727C6.29662 4.81248 6.24419 4.86754 6.18652 4.927L5.85645 5.26294C5.77661 5.34139 5.63478 5.48346 5.51367 5.60571C5.45323 5.66673 5.39779 5.72303 5.35742 5.76392C5.33723 5.78436 5.32094 5.80122 5.30957 5.81274L5.30859 5.81372L2.21387 2.83032L2.17187 2.79028L2.17187 4.97778L0.525391 4.97778L0.52539 0.834229Z"
          fill="#05050D"
          fillOpacity="0.8"
          stroke="white"
          strokeWidth="0.05"
        />
      </svg>
    </Button>
  );
};
